// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__Gk20s","title":"Images45_title__3QBsH","images":"Images45_images__2tg9r"};